<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModalInserirDotacao()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Dotação Orçamentária
            </span>
        </b-button>
        <b-modal
            id="modalInserirDotacao"
            v-model="mostrarModalInserirDotacao"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Dotação Orçamentária -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O que deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade</label>
                        <b-form-select
                            :options="unidades"
                            v-model="codUnidade"
                            text-field="nome"
                            value-field="codUnidade"
                            @input="$v.codUnidade.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Projeto</label>
                        <b-form-select
                            :options="projetos"
                            v-model="codProjeto"
                            text-field="nome"
                            value-field="codProjeto"
                            @input="$v.codProjeto.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Ação</label>
                        <b-form-select
                            :options="acoes"
                            v-model="codAcao"
                            text-field="nome"
                            value-field="codAcao"
                            @input="$v.codAcao.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirDotacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarDotacao()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import UnidadesServicos from './../../rm/UnidadesServicos'
import ProjetosServicos from './../../rm/ProjetosServicos'
import AcoesServicos from './../../rm/AcoesServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalInserirDotacao: false,
            obterDotacoesAtualizadas: false,
            operacao: 'INSERÇÃO',
            erros: [],
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            unidades: [],
            projetos: [],
            acoes: [],
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        obterUnidades() {
            this.$store.dispatch('addRequest')
            UnidadesServicos.obterUnidadesProjetosAcoesPorDotacao2().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.unidades = response.data.unidades
                            this.projetos = response.data.projetos
                            this.acoes = response.data.acoes
                            this.codUnidade = this.unidades[0].codUnidade
                            this.codProjeto = this.projetos[0].codProjeto
                            this.codAcao = this.acoes[0].codAcao
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            ProjetosServicos.obterTodosPorUnidade(this.codUnidade).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.projetos = response.data
                            if (this.projetos) {
                                this.codProjeto = this.projetos[0].codProjeto
                            }
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            AcoesServicos.obterTodasPorProjeto(
                this.codUnidade,
                this.codProjeto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                        if (this.acoes) {
                            this.codAcao = this.acoes[0].codAcao
                        }
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrirModalInserirDotacao() {
            this.mostrarModalInserirDotacao = true
        },

        fecharModalInserirDotacao() {
            this.mostrarModalInserirDotacao = false
            this.resetInserirDotacao()
            if (this.obterDotacoesAtualizadas) {
                this.$emit('obterDotacoesAtualizadas')
            }
        },

        resetInserirDotacao() {
            this.justificativaApostilamento = ''
            this.erros = []
            this.codUnidade = null
            this.codProjeto = null
            this.codAcao = null
            this.unidades = []
            this.projetos = []
            this.acoes = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterUnidades()
        },

        confirmarSalvarDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a inserção da dotação orçamentária no contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDotacao()
                }
            })
        },

        salvarDotacao() {
            this.$store.dispatch('addRequest')
            let dotacaoDto = {
                idRateioComprometimento: 0,
                idContrato: this.$route.params.contratoId,
                codUnidade: this.codUnidade,
                codProjeto: this.codProjeto,
                codAcao: this.codAcao,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarDotacaoContrato(dotacaoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.obterDotacoesAtualizadas = true
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.fecharModalInserirDotacao()
        },

        registrosInalterados() {
            return (
                this.codUnidade === null &&
                this.codProjeto === null &&
                this.codAcao === null
            )
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-02')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-02')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
    },

    watch: {
        codUnidade(newVal, oldVal) {
            if (oldVal !== null && newVal !== null) {
                this.obterProjetos()
            }
        },

        codProjeto(newVal, oldVal) {
            if (oldVal !== null && newVal !== null) {
                this.obterAcoes()
            }
        }
    },

    validations: {
        IdRateioComprometimento: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        codUnidade: {
            required
        },
        codProjeto: {
            required
        },
        codAcao: {
            required
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
